import axios from "axios";
import React from "react";

import { MapPinIcon } from "@heroicons/react/20/solid";
import { useDispatch } from "react-redux";
import { TwListMoreButton, TwMoreOptions } from "../../../components/tailwind";
import { useLocalStorage } from "../../../hooks";
import { setSectionLoading } from "../../../redux/reducers/loadingReducer";
import { getUrlForServices } from "../../../utils/confighelpers";

export default function VenueTile({
  popover,
  handleSessionClick,
  reload,
  item,
}) {
  const [userToken] = useLocalStorage("userToken");
  const dispatch = useDispatch();
  const deleteVenues = async (id) => {
    dispatch(setSectionLoading(true));
    const manageClassesConfig = {
      method: "delete",
      url: `${getUrlForServices()}venue/${id}`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const responce = await axios(manageClassesConfig);
    if (responce.status === 200) {
    }
    reload();
    dispatch(setSectionLoading(false));
  };

  return (<li className="flex items-center justify-between gap-x-6 p-5 rounded-xl hover:bg-list-hover">
    <div className="flex min-w-0 gap-x-4">
      <div className="size-12 min-w-12 flex justify-center items-center bg-brown-coffee rounded-xl object-fill"><MapPinIcon className="size-7 fill-white" /></div>
      <div className="min-w-0 flex-auto">
        <p className="truncate text-sm/6 font-semibold text-gray-900">{item?.venueName || item.address.addressName}</p>
        <p className="mt-1 truncate text-xs/5 text-gray-500">{item.address.address}</p>
      </div>
    </div>
    <div className="flex flex-none items-center gap-x-4">
      <TwMoreOptions
        options={[
          <TwListMoreButton
            className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
            onClick={() => {
              handleSessionClick();
            }}
          >
            Edit
          </TwListMoreButton>,
          // <TwListMoreButton
          //   className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
          //   onClick={() => {
          //     // deleteVenues(item._id);
          //   }}
          // >
          //   Delete
          // </TwListMoreButton>
        ]} />
    </div>
  </li>);
}
